/*
  Horelya — barre d'achat collante de la fiche produit (sections/horelya-sticky-atc.liquid).

  Discrète par principe :
  - elle n'apparaît qu'une fois le bouton « Ajouter au panier » principal dépassé (pas au chargement) ;
  - elle disparaît dès que ce bouton revient à l'écran, et au niveau du pied de page ;
  - masquée, elle est inerte (ni clic, ni focus clavier, ni lecteur d'écran).

  Elle ne duplique aucune logique d'achat : son bouton clique le bouton principal de Dawn,
  donc variantes, choix Duo/Trio (assets/horelya-lots.js), vérifications et tiroir panier restent les mêmes.
  Elle recopie seulement ce qui est affiché : choix en cours et prix, état « épuisé ».
*/
if (!customElements.get('horelya-sticky-atc')) {
  class HorelyaStickyAtc extends HTMLElement {
    connectedCallback() {
      this.productInfo = document.querySelector('product-info');
      this.mainButton = this.productInfo && this.productInfo.querySelector('product-form [name="add"]');
      this.button = this.querySelector('[data-sticky-add]');
      this.meta = this.querySelector('[data-sticky-meta]');
      if (!this.mainButton || !this.button || !('IntersectionObserver' in window)) return;

      this.label = this.button.textContent.trim();
      this.pastButton = false;
      this.footerInView = false;
      this.toggle(false);

      this.observer = new IntersectionObserver(this.onIntersect.bind(this));
      this.observer.observe(this.mainButton);
      this.footer = document.querySelector('footer.footer');
      if (this.footer) this.observer.observe(this.footer);

      this.syncButton = this.syncButton.bind(this);
      this.syncMeta = this.syncMeta.bind(this);
      this.buttonObserver = new MutationObserver(this.syncButton);
      this.buttonObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
      this.productInfo.addEventListener('change', this.syncMeta);
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(this.syncMeta));
      }

      this.button.addEventListener('click', () => this.mainButton.click());
      this.syncButton();
      this.syncMeta();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.buttonObserver) this.buttonObserver.disconnect();
      if (this.productInfo) this.productInfo.removeEventListener('change', this.syncMeta);
      if (this.unsubscribe) this.unsubscribe();
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.target === this.mainButton) {
          this.pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        } else {
          this.footerInView = entry.isIntersecting;
        }
      });
      this.toggle(this.pastButton && !this.footerInView);
    }

    toggle(show) {
      this.classList.toggle('is-visible', show);
      this.inert = !show;
      this.setAttribute('aria-hidden', String(!show));
    }

    // Épuisé / indisponible : même état et même texte que le bouton principal.
    syncButton() {
      const disabled = this.mainButton.hasAttribute('disabled');
      const mainLabel = this.mainButton.querySelector('span');
      this.button.disabled = disabled;
      this.button.textContent = disabled && mainLabel ? mainLabel.textContent.trim() : this.label;
    }

    // « 1 flacon · 45,00 € », « Duo signature · 85,00 € »… ou le prix seul s'il n'y a pas de choix de lot.
    syncMeta() {
      if (!this.meta) return;
      const lot = this.productInfo.querySelector('horelya-lots input[type="radio"]:checked');
      const option = lot && lot.closest('.horelya-lots__option');
      if (option) {
        const title = option.querySelector('.horelya-lots__title');
        const price = option.querySelector('.horelya-lots__price');
        const amount = price && price.firstChild ? price.firstChild.textContent.trim() : '';
        this.meta.textContent = [title && title.textContent.trim(), amount].filter(Boolean).join(' · ');
        return;
      }
      const price = this.productInfo.querySelector('[id^="price-"] .price-item--last');
      if (price) this.meta.textContent = price.textContent.trim();
    }
  }

  customElements.define('horelya-sticky-atc', HorelyaStickyAtc);
}
